import { useEffect, useState } from "react";
import { PieChart, pieArcLabelClasses } from "@mui/x-charts/PieChart";

export default function PieChartPopularSubs(props) {
  const [width, setWidth] = useState(260);
  const [radius, setRadius] = useState(50);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2133) {
        setWidth(280);
        setRadius(55);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setWidth(260);
        setRadius(50);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setWidth(240);
        setRadius(45);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setWidth(220);
        setRadius(40);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setWidth(200);
        setRadius(35);
      } else {
        setWidth(260);
        setRadius(50);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const sizing = {
    margin: { right: 10, left: 10 },
    width: width,
    height: width,
    legend: { hidden: true },
  };

  return (
    <PieChart
      series={[
        {
          arcLabel: (item) => `${item.value}%`,
          arcLabelMinAngle: 25,
          innerRadius: radius * 0.8,
          paddingAngle: 2,
          cornerRadius: 10,
          highlightScope: { fade: "global", highlight: "item" },
          faded: { additionalRadius: -10, color: "gray" },
          data: props?.data,
          valueFormatter: (v) => (
            <div className="font-bold text-[0.925em]">{v.value}%</div>
          ),
        },
      ]}
      tooltip={{ trigger: "item" }}
      sx={{
        [`& .${pieArcLabelClasses.root}`]: {
          fill: "white",
          fontWeight: 600,
          fontSize: "0.825em",
        },
      }}
      {...sizing}
    />
  );
}
